/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefTryItRequestData } from '../../models/api-def-try-it-request-data';

export interface TryItProxyRequest$Params {

/**
 * The fully qualified URL of the external endpoint to test.
 */
  url: string;
      body: {

/**
 * The ID of the project to associate with the request.
 */
'projectId': string;

/**
 * The ID of the organization to associate with the request.
 */
'organizationId': string;

/**
 * The path of the endpoint to test.
 */
'endpointPath'?: string;

/**
 * Path parameters to include in the request.
 */
'pathParameters'?: ({
[key: string]: string;
}) | null;

/**
 * HTTP method to use for the request.
 */
'method': 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'HEAD' | 'OPTIONS';

/**
 * HTTP headers to include in the request.
 */
'headers'?: ({
[key: string]: string;
}) | null;

/**
 * Reserved for client compatibility. Cookies are not forwarded while the
 * credential-forwarding product policy remains undecided.
 */
'cookies'?: ({
[key: string]: string;
}) | null;

/**
 * Query parameters to include in the request.
 */
'query'?: {
[key: string]: string;
};

/**
 * Request payload. Use JSON for structured data or string for raw data.
 */
'body'?: ({
} | null | string | null);
}
}

export function tryItProxyRequest(http: HttpClient, rootUrl: string, params: TryItProxyRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefTryItRequestData>> {
  const rb = new RequestBuilder(rootUrl, tryItProxyRequest.PATH, 'post');
  if (params) {
    rb.query('url', params.url, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefTryItRequestData>;
    })
  );
}

tryItProxyRequest.PATH = '/tryIt';
